import { render, staticRenderFns } from "./manageLimitation.pug?vue&type=template&id=11048897&lang=pug&"
import script from "./manageLimitaion.ts?vue&type=script&lang=ts&"
export * from "./manageLimitaion.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports